import React, { useState, useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Tooltip } from "primereact/tooltip";
import "./QuestionsModal.scss";
import addIcon from "../../assets/addWhiteIcon.png";
import Excalmation from "../../assets/Exclamation.png";
import updateIconImg from "../../assets/updateIconImg.png";
import deleteIconImg from "../../assets/deleteIcon.png";
import ModalHeader from "../../components/Header/ModalHeader";
import DialogComponent from "../../components/Dialog";
import QuestionForm from "./QuestionsForm";
import { deleteQuestion, getQuestion } from "../../services/QuestionService";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { Toast } from 'primereact/toast';

const getUniqueValuesByKey = (data, key) => {
  const values = data.map((item) => item[key]);
  return [...new Set(values)];
};

function QuestionsView() {
  const [dataitem, setDataitem] = useState([]);
  const [showAddQuestionModal, setShowAddQuestionModal] = useState(false);
  const [selectedQuestions, setSelectedQuestions] = useState([]);
  const [filters, setFilters] = useState({});
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const toast = useRef(null);

  const fetchQuestions = async (page, pageSize) => {
  try {
    const response = await getQuestion(page, pageSize);
    const questionArray = Array.isArray(response.data)
      ? response.data
      : response?.data || [];
      setDataitem(questionArray);
      setPage(response.page);
      setPageSize(response.pageSize);
      setTotalCount(response.total);
  } catch (error) {
    setDataitem([]);
    setTotalCount(0);
    console.error("Error fetching Questions:", error);
  }
};
  useEffect(() => {
    fetchQuestions(page,pageSize);
  }, [page,pageSize]);
  const handleQuestionClick = () => {
    setShowAddQuestionModal(true);
  };
  const handleModalClose = () => {
    setShowAddQuestionModal(false);
    fetchQuestions(page,pageSize);
  };
  const handleUpdateQuestionClick = () => {
    if (selectedQuestions.length === 1) {
      const questionData = selectedQuestions[0];
      navigate("/questions?tab=edit", {
        state: {
          mode: "update",
          question: questionData,
        },
      });
      setShowAddQuestionModal(true);
    }
  };
  const onFilter = (e, field) => {
   const value = e.target.value.toLowerCase();
   const newFilters = { ...filters };
   newFilters[field] = value;
   setFilters(newFilters);
   };
   const searchTemplate = (field) => {
   const placeholderText = field.includes(".")
     ? `Search ${field 
     .split(".")
     .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
     .join(" ")}`
     : `Search ${field}`;
   return (
     <InputText
       value={filters[field] || ""}
       onChange={(e) => onFilter(e, field)}
       placeholder={placeholderText}
       className="p-column-filter"
     />
   );
 };
   const filteredData = dataitem.filter((item) =>
   Object.keys(filters).every((key) => {
     const keys = key.split(".");
     const value = keys.reduce((acc, k) => acc?.[k], item);
     return value?.toString().toLowerCase().includes(filters[key]);
   })
 );
  const handleTablePageChange = (newPage, newPageSize) => {
    setPage(newPage);
    setPageSize(newPageSize);
  };
  const renderTooltipComponent = (rowData) =>
    rowData.validStatus !== "Valid" && rowData.remarks ? (
      <>
        <Tooltip target={`#tooltip_${rowData.id}`} mouseTrack>
          <div className="tooltip-content">{rowData.remarks}</div>
        </Tooltip>
        <span id={`tooltip_${rowData.id}`} data-testid="Exclamation">
          <img src={Excalmation} alt="Exclamation" />
        </span>
      </>
    ) : null;
  const getBorderClassName = () => "border-second";

  const handleDeleteQuestion = async () => {
    if (selectedQuestions.length === 0) {
      toast.current.show({
        severity: "warn",
        summary: "Warning",
        detail: "Please select at least one Question to delete.",
        life: 3000,
      });
      return;
    }
    confirmDialog({
      message: `Are you sure you want to delete the selected Question`,
      header: "Confirmation",
      icon: "pi pi-info-circle",
      accept: async () => {
        let successCount = 0;
        let failedCount = 0;

        for (const question of selectedQuestions) {
          try {
            await deleteQuestion(question.id);
            successCount++;
          } catch (error) {
            console.error("Error deleting question:", error.message);
            toast.current.show({
              severity: "warn",
              summary: "Warning",
              detail: error.message || "Failed to delete question.",
              life: 5000,
            });
            failedCount++;
          }
        }
        if (successCount > 0) {
          toast.current.show({
            severity: "success",
            summary: "Success",
            detail: `Question deleted successfully.`,
            life: 3000,
          });
        }
        setSelectedQuestions([]);
        fetchQuestions();
      },
    });
  };

  return (
    <>
    <Toast ref={toast} />
      <div className="masterScreen">
                <div className="grid flex justify-content-end mb-4" style={{ marginLeft: '49.5rem'}}>
          <div className="md:col-6 col-div" />
          <div className="sm:col-12 md:col-6 button_section">            
            <div className="flex justify-content-end align-items-center mt-4 mb-2 gap-18 w-full">
              <div className="flex justify-content-end align-items-center mb-2 gap-2 w-full">
                <Button
                  className="master-updateBtn"
                  label="Update"
                  severity="info"
                  icon={<img src={updateIconImg} alt="Update icon" />}
                  outlined
                  disabled={selectedQuestions.length !== 1}
                  tooltip="Update Question"
                  tooltipOptions={{ position: "bottom", event: "both" }}
                  onClick={() => {
                      if (selectedQuestions.length === 1) {
                        const questionsData = selectedQuestions[0];
                        navigate(`/questions?tab=edit`, {
                          state: {
                            mode: "update",
                            question: questionsData,
                          },
                        });
                        handleQuestionClick();
                      }
                    }}
                />
                <Button
                  className="master-deleteBtn"
                  label="Delete"
                  severity="danger"
                  icon={<img src={deleteIconImg} alt="Delete icon" />}
                  outlined
                  disabled={selectedQuestions.length === 0}
                  onClick={handleDeleteQuestion}
                />
                <Button
                  className="addBtn"
                  label="Add New Question"
                  icon={<img src={addIcon} alt="Add icon" />}
                  disabled={selectedQuestions.length > 0}
                  tooltip="Add New Question"
                  tooltipOptions={{ position: "bottom", event: "both" }}
                  onClick={() => {
                    navigate("/questions?tab=add");
                    handleQuestionClick();
                  }}
                />
              </div>
            </div>
          </div>
        </div>
        <DataTable
          lazy
          className="table-viewport custom-tooltip"
          resizableColumns
          value={filteredData}
          size="small"
          dataKey="id"
          emptyMessage="No data found."
          filterDisplay="row"
          scrollable
          scrollHeight="510px"
          paginator
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
          currentPageReportTemplate="{first} to {last} of {totalRecords}"
          rows={pageSize}
          first={(page - 1) * pageSize}
          rowsPerPageOptions={[5, 10, 20, 50]} 
          onPage={(e) => {
            const newPage = Math.floor(e.first / e.rows) + 1;
            const newPageSize = e.rows;
            handleTablePageChange(newPage, newPageSize);
          }}
          totalRecords={totalCount}
          selection={selectedQuestions}
          onSelectionChange={(e) => setSelectedQuestions(e.value)}
        >
          <Column
            selectionMode="multiple"
            header="Select"
            frozen
            alignFrozen="left"
          />
          <Column
            frozen
            alignFrozen="left"
            body={renderTooltipComponent}
          />
          <Column
            frozen
            alignFrozen="left"
            field="queTranslations.text"
            header="Question"
            filter
            showFilterMenu={false}
            filterPlaceholder="Search"
            filterElement={() => searchTemplate("queTranslations.text")}
            style={{ cursor: "pointer" }}
          />
          <Column
            frozen
            alignFrozen="left"
            field="total_options"
            header="Total Options"
            bodyStyle={{ textAlign: "center", justifyContent: "center" }}
            style={{ cursor: "pointer" }}
          />
          <Column
            frozen
            alignFrozen="left"
            field="Course.title"
            header="Course"
            filter
            showFilterMenu={false}
            filterPlaceholder="Search"
            filterElement={() => searchTemplate("Course.title")}
            style={{ cursor: "pointer" }}
          />
          <Column
            frozen
            alignFrozen="left"
            field="Module.title"
            header="Module"
            filter
            showFilterMenu={false}
            filterPlaceholder="Search"
            filterElement={() => searchTemplate("Module.title")}
            style={{ cursor: "pointer" }}
          />
          <Column
            frozen
            alignFrozen="left"
            field="Topic.title"
            header="Topic"
            filter
            showFilterMenu={false}
            filterPlaceholder="Search"
            filterElement={() => searchTemplate("Topic.title")}
            style={{ cursor: "pointer" }}
          />
          <Column
            frozen
            headerStyle={{
              borderRight: "3px solid #d9d9d9",
              position: "sticky",
            }}
            bodyStyle={{
              borderRight: "3px solid #d9d9d9",
              position: "sticky",
            }}
            alignFrozen="left"
            className={getBorderClassName()}
          />
        </DataTable>
        <p className="text-sm">{totalCount} Total record</p>
      </div>
      <DialogComponent
        visible={showAddQuestionModal}
        onHide={handleModalClose}
        header={
          <ModalHeader onClose={handleModalClose} backText="Back To Question" />
        }
        style={{
          width: "100vw",
          maxWidth: "1000px",
          height: "100vh",
        }}
      >
        <QuestionForm
        onClose={handleModalClose}
        onFormSubmit={() => setSelectedQuestions([])} />
      </DialogComponent>
      <ConfirmDialog />
    </>
  );
}

export default QuestionsView;